import React, { useMemo } from 'react';
import Loadable from 'react-loadable';
import { Loading } from 'components';
import { useMergedConfig, useDeviceTypeIsMobile } from '@/hooks';
import { PortfolioContainerProps } from 'views/Portfolio';
import { shorten } from '@/utils';
import { getCurrentTabName } from './utils';
import { useLocation } from 'react-router-dom';
import { CustomTitle } from '@/components/CustomTitle';

export const DesktopContainer = Loadable({
  loader: () => import('./DesktopContainer'),
  loading: () => <Loading />,
  delay: 500,
});

export const MobileContainer = Loadable({
  loader: () => import('./MobileContainer'),
  loading: () => <Loading />,
  delay: 500,
});

const Container = ({
  urlAddress,
  currentAddress,
}: Omit<PortfolioContainerProps, 'viewConfig' | 'refetchConfig'>) => {
  const location = useLocation();
  const isMobile = useDeviceTypeIsMobile();

  const { data, isLoading, refetch: refetchConfig } = useMergedConfig(urlAddress);

  const titlePrefix = useMemo(() => {
    const tabName = getCurrentTabName(location.pathname);
    return `${tabName} of ${shorten(urlAddress, 6, 4)}`;
  }, [location.pathname, urlAddress]);

  return (
    <>
      <CustomTitle titlePrefix={titlePrefix} />
      {isLoading ? null : !isMobile ? (
        <DesktopContainer
          urlAddress={urlAddress}
          currentAddress={currentAddress}
          viewConfig={data!}
          refetchConfig={refetchConfig}
        />
      ) : (
        <MobileContainer
          urlAddress={urlAddress}
          currentAddress={currentAddress}
          viewConfig={data!}
          refetchConfig={refetchConfig}
        />
      )}
    </>
  );
};

export default React.memo(Container);
